
import { AtualizarGrupoPayload, AtualizarGrupoUsuarioPayload, BuscarGrupoQuery, CadastrarGrupoPayload, AtualizarPermissaoPayload } from '../../interfaces/grupos'
import BASEURLGESTTOR from '../api/gesttor'
import BASEURLZAI from '../api/zai'

export function novoGrupo(params: CadastrarGrupoPayload) {
    return BASEURLZAI.post('/grupos', params)
}

export function listarGrupos(params: BuscarGrupoQuery) {
    return BASEURLZAI.get('/grupos', { params })
}

export function atualizarGrupo(idGrupo: string, payload: AtualizarGrupoPayload) {
    return BASEURLZAI.patch(`/grupos/${idGrupo}`, payload)
}

export function atualizarPermissao(payload: AtualizarPermissaoPayload) {
    return BASEURLZAI.put(`/permissao`, payload)
}

export function atualizarGruposUsuario(payload: AtualizarGrupoUsuarioPayload) {
    return BASEURLGESTTOR.patch(`/grupo/usuarios`, payload)
}

export function buscarPermissao() {
    return BASEURLZAI.get(`/permissao/grupo/usuario`)
}